import {normalizeIntegerLength} from "components/FormElements/normalizeInteger";

export default v => normalizeIntegerLength(5)(v);